import counterpart from 'counterpart';
import { initCommonTranslate } from 'Utils/languages';
export function getPopupTranslations() {
  initCommonTranslate();
  return {
    cancel: counterpart('globalTranslate.activateStage.cancel'),
    activate: counterpart('globalTranslate.activateStage.activate'),
    confirmationMsg: counterpart('globalTranslate.activateStage.confirmationMsg'),
    title: counterpart('globalTranslate.activateStage.title'),
    dataColumns: [
      {
        description: counterpart('globalTranslate.activateStage.comments'),
        name: counterpart('globalTranslate.activateStage.comments'),
        displayType: 'COMMENTS',
        isRequired: true,
        textAreaMaxLength: 160,
        float: 'right',
      },
    ],
  };
}
